import React, { useEffect, useState } from "react";
import client from "@culturehq/client";
import { ActionButton } from "@culturehq/components";

import { useProfile } from "app/context";
import { useIsMounted } from "app/hooks";
import { Trans } from "app/utils";

const StaticWidgetToggle = ({ disabled, name }) => {
  const { refreshProfile } = useProfile();
  const isMounted = useIsMounted();

  const [toggling, setToggling] = useState(false);
  const onClick = () => setToggling(true);

  useEffect(
    () => {
      if (toggling) {
        client[disabled ? "enableStaticWidget" : "disableStaticWidget"]({ widget: name })
          .then(() => refreshProfile())
          .then(() => {
            if (isMounted) {
              setToggling(false);
            }
          });
      }
    },
    [disabled, isMounted, name, refreshProfile, toggling]
  );

  return (
    <ActionButton onClick={onClick} disabled={toggling} className="pull-right">
      {disabled ? <Trans>Enable</Trans> : <Trans>Disable</Trans>}
    </ActionButton>
  );
};

export default StaticWidgetToggle;
